<script setup lang="ts">
interface HotelSelectionMobileLayoutProps {
  hasFixedHeight?: boolean;
  contentFullScreen?: boolean;
}
const props = defineProps<HotelSelectionMobileLayoutProps>();
</script>

<template>
  <div
    :class="[
      'hotel-selection-mobile-layout',
      { 'fixed-height': !!props.hasFixedHeight },
    ]"
  >
    <div class="header">
      <slot name="header" />
    </div>

    <div class="content" :class="{ 'full-screen': props.contentFullScreen }">
      <slot name="content" />
    </div>

    <div class="list-map-switch">
      <slot name="list-map-switch" />
    </div>
  </div>
</template>

<style scoped lang="scss">
.hotel-selection-mobile-layout {
  position: relative;

  display: flex;
  flex-direction: column;

  min-height: 100vh;
  min-height: 100svh;

  background-color: var(--color-white);

  &.fixed-height {
    height: 100vh;
    height: 100svh;
  }

  .header {
    display: contents;
    position: relative;
    z-index: 2;
  }

  .content {
    flex-grow: 1;
    position: relative;
    z-index: 1;
    background: var(--color-off-white);

    &.full-screen {
      z-index: 3;
      position: fixed;
      width: 100dvw;
      height: 100svh;
    }
  }

  .list-map-switch {
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    margin-bottom: var(--spacing-24);
    z-index: 4;
  }
}
</style>

<style lang="scss">
.hotel-selection-mobile-layout {
  box-sizing: border-box;

  * {
    box-sizing: border-box;
  }
}
</style>
